import React, { useEffect, useState } from 'react';
import { useCreateOrder, useDeleteOrder, useGetOrders, useUpdateOrder } from '../../networking/useOrder';
import { isNonEmpty } from '../../utils/arrayUtils';
import Loading from '../../components/base/Loading';
import { Text } from '../../components/base/Text';
import { formatDate } from 'date-fns';
import EditableTable from '../../components/base/Table';
import { Button } from '../../components/base/Button';
export const OrdersView = () => {
    const [orders, setOrders] = useState([]);
    const [colDefs, setColDefs] = useState([]);
    const { isLoading, data, call } = useGetOrders();
    const { isLoading: isLoadingCreate, data: dataCreate, call: callCreate } = useCreateOrder();
    const { data: dataUpdate, call: callUpdate } = useUpdateOrder();
    const { data: dataDelete, call: callDelete } = useDeleteOrder();
    const displayMapping = {
        order_date: 'Date',
        vendor: 'Vendor',
        product_id: 'Product ID',
        sku: 'SKU',
        quantity: 'Quantity',
        unit_price: 'Unit price ($)',
        total_price: 'Total price ($)',
        // status: 'Status',
    };
    useEffect(() => {
        if (data && isNonEmpty(data.items)) {
            const ordersTrasformed = data.items.map((order) => {
                order['key'] = order.id;
                order['order_date'] = formatDate(order.order_date_utc, 'MM-dd-yyyy');
                return order;
            });
            setOrders(ordersTrasformed);
        }
    }, [data]);
    useEffect(() => {
        if (isNonEmpty(dataCreate)) {
            const newData = [...orders, dataCreate[0]];
            const ordersTrasformed = newData.map((order) => {
                order['key'] = order.id;
                order['order_date'] = formatDate(order.order_date_utc, 'MM-dd-yyyy');
                return order;
            });
            setOrders(ordersTrasformed);
        }
    }, [dataCreate]);
    useEffect(() => {
        const columnFields = Object.keys(displayMapping).map((col, index) => {
            return { dataIndex: col, key: col, title: displayMapping[col], editable: true };
        });
        setColDefs(columnFields);
        call();
    }, []);
    const onSave = (id, item) => {
        callUpdate({ entity_id: id, fields_to_update: item });
    };
    const onDelete = (id) => {
        callDelete({ entity_id: id });
    };
    const addRow = () => {
        callCreate({
            entities: [{ product_id: 'Product A', sku: '123', quantity: 1, unit_price: 1, total_price: 1 }],
        });
    };
    return (React.createElement("div", { style: { padding: '1.5vw', overflowY: 'auto', gap: 24 } },
        React.createElement(Text, { value: 'Orders', className: "header1" }),
        React.createElement("div", { style: { paddingTop: '1vw' } }, isLoading ? (React.createElement(Loading, null)) : isNonEmpty(orders) ? (React.createElement(React.Fragment, null,
            React.createElement(EditableTable, { tableData: orders, tableColumns: colDefs, addEditColumn: true, onSave: onSave, onDelete: onDelete }),
            React.createElement(Button, { isLoading: isLoadingCreate, onClick: addRow, style: {}, text: "Add order" }))) : (React.createElement("div", { className: "flex-column", style: { width: '20%' } },
            React.createElement(React.Fragment, null, "No orders found"),
            React.createElement(Button, { isLoading: isLoadingCreate, onClick: addRow, style: { marginTop: 16 }, text: "Add order" }))))));
};
